import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import Menu from 'ui-library/menus/Menu';
import {OptionData} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

export interface FillPlateFromStructuredTableDropdownProps {
  /** Whether the entire dropdown should be disabled */
  disabled: boolean;
  /** What should be displayed in the closed dropdown */
  displayName: string;
  /** A kebab-case suffix for this input; will be used to associate label with dropdown */
  idSuffix: string;
  /** The text of the label for this input */
  label: string;
  /** A function to be called when a new option is chosen */
  onSelect: (selectedValue: string) => void;
  /** The options to be shown in the dropdown */
  optionDatas: Array<OptionData>;
  /** Which of the dropdown options is selected */
  selectedValue: string;
}

export default function FillPlateFromStructuredTableDropdown({
  disabled,
  displayName,
  idSuffix,
  label,
  onSelect,
  optionDatas,
  selectedValue,
}: FillPlateFromStructuredTableDropdownProps): JSX.Element {
  return (
    <InputWrapper id={`add-from-structured-table-${idSuffix}`} label={label} labelStyle={LabelStyle.LABEL}>
      <SelectDropdown
        id={`add-from-structured-table-${idSuffix}`}
        className={css(styles.dropdownToggle)}
        closeOnInsideClick={true}
        closeOnOutsideClick={true}
        disabled={disabled}
        displayName={displayName}
        menu={
          <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FIT_CONTENT}>
            {optionDatas.map((optionData) => (
              <Option
                isDisabled={optionData.disabled}
                isSelected={optionData.value === selectedValue}
                key={optionData.value}
                onSelect={onSelect}
                tooltipTitle={optionData.tooltipTitle}
                value={optionData.value}
              >
                {optionData.name}
              </Option>
            ))}
          </Menu>
        }
        shouldEllipsize={true}
        shouldGrowDisplayName={true}
      />
    </InputWrapper>
  );
}

const styles = StyleSheet.create({
  dropdownToggle: {
    flex: '1 1 auto',
  },
});
